import React, { useState } from 'react';
import { Box, Typography, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { AdminAdvertisementComponent } from '../../Pages/adminMgmt/adminAdvatizement';
import { AdminAuctionComponent } from '../../Pages/adminMgmt/adminAuction';
import { AdminCalendarEvents } from '../../Pages/adminMgmt/adminCalenderEvents';
import { AdminCircularNotificationComponent } from '../../Pages/adminMgmt/adminCircularNotification';
import { AdminDailyCourtCasesComponent } from '../../Pages/adminMgmt/adminDailyCourtReport';
import { AdminFEComponent } from '../../Pages/adminMgmt/adminFe';
import { AdminAssignedFinancialEstablishmentComponent } from '../../Pages/adminMgmt/adminFinancialEstablishment';
import { AdminGovtOrdersComponent } from '../../Pages/adminMgmt/adminGovtOrder';
import { AdminHeadOfficeComponent } from '../../Pages/adminMgmt/adminHeadOffice';
import { AdminDepositorInfoComponent } from '../../Pages/adminMgmt/adminInfoToDepositor';
import { AdminKeyJudgementComponent } from '../../Pages/adminMgmt/adminKeyJudgement';
import { AdminKpidActComponent } from '../../Pages/adminMgmt/adminKpidRules';
import { AdminManualVideosComponent } from '../../Pages/adminMgmt/adminManualVideos';
import { AdminOfficeOrdersComponent } from '../../Pages/adminMgmt/adminOfficeOrders';
import { AdminTenderComponent } from '../../Pages/adminMgmt/adminTenders';
import { AdminNewsComponent } from '../../Pages/adminMgmt/adminNews';
import { AdminNotificationComponent } from '../../Pages/adminMgmt/adminNotification';
import { AdminLegalTeamComponent } from '../../Pages/adminMgmt/adminLegalTeam';
import {AdminBudsActComponent} from '../../Pages/adminMgmt/adminBudsAct'
import { AdminDailySupremeCourtCasesComponent } from '../../Pages/adminMgmt/adminDailySupremeCourtCases';
import { AdminDailyHighCourtCasesComponent } from '../../Pages/adminMgmt/adminDailyHighCortCases';
import { AdminOtherStatePIDFEComponent } from '../../Pages/adminMgmt/adminOtherStatePIDFE';
import { AdminOtherReleventActComponent } from '../../Pages/adminMgmt/adminOtherReleventActs';
import { AdminComparissnOfActComponent } from '../../Pages/adminMgmt/AdminComparisnOfActs';
import {AdminLegalTemplateComponent}from '../../Pages/adminMgmt/adminLegalTemplate';
import {AdminFaqComponent} from '../../Pages/adminMgmt/adminFaq';
import {AdminLegalBlogsComponent} from '../../Pages/adminMgmt/adminLegalBlog';
import {AdminScamNewsComponent} from '../../Pages/adminMgmt/adminScamNews'
import { AdminHighCourtComponent } from '../../Pages/adminMgmt/adminHighCourtOrders';
import { AdminSupremeCourtComponent } from '../../Pages/adminMgmt/supremeCourtOrders';
import { AdminOtherStateCourtComponent } from '../../Pages/adminMgmt/adminOtherStateCourtOrders';
import { AdminSOPComponent } from '../../Pages/adminMgmt/adminSop';
import { AdminLegalOpinionComponent } from '../../Pages/adminMgmt/adminLegalOpinion';
import { AdminLegalResearchComponent } from '../../Pages/adminMgmt/AdminLegalResearch';
import OrgChartAdmin from '../../Pages/orgChart/adminChart';
import AdminPropertyComponent from '../../Pages/adminMgmt/adminPropertyMap';


const DropdownComponent = () => {
  const [selectedOption, setSelectedOption] = useState('');

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const renderComponent = () => {
    switch (selectedOption) {
      case 'A':
        return <Box><AdminAdvertisementComponent /></Box>;
      case 'B':
        return <Box><AdminAuctionComponent/></Box>;
      case 'C':
        return <Box><AdminCalendarEvents/></Box>;

      case 'D':
        return <Box><AdminCircularNotificationComponent/></Box>;
      case 'E':
        return <Box><AdminDailyCourtCasesComponent/></Box>;
      case 'F':
        return <Box><AdminFEComponent/></Box>;
      case 'G':
        return <Box><AdminAssignedFinancialEstablishmentComponent/></Box>;
      case 'H':
        return <Box><AdminGovtOrdersComponent/></Box>;
      case 'I':
        return <Box><AdminHeadOfficeComponent/></Box>;
      case 'J':
        return <Box><AdminDepositorInfoComponent/></Box>;
      case 'K':
        return <Box><AdminKeyJudgementComponent/></Box>;
      case 'L':
        return <Box><AdminKpidActComponent/></Box>;
      case 'M':
        return <Box><AdminManualVideosComponent/></Box>;
      case 'N':
        return <Box><AdminOfficeOrdersComponent/></Box>;
      case 'O':
        return <Box><AdminTenderComponent/></Box>;
      case 'P':
        return <Box><AdminNewsComponent/></Box>;
      case 'Q':
        return <Box><AdminNotificationComponent/></Box>;
      case 'R':
        return <Box><AdminLegalTeamComponent/></Box>;
      case 'S':
        return <Box><AdminBudsActComponent/></Box>
      case 'T':
        return <Box><AdminDailySupremeCourtCasesComponent/></Box>
      case 'U':
        return <Box><AdminDailyHighCourtCasesComponent/></Box>
      case 'V':
        return <Box><AdminOtherStatePIDFEComponent/></Box>
      case 'W':
        return <Box><AdminOtherReleventActComponent/></Box>
      case 'X':
        return <Box><AdminComparissnOfActComponent/></Box>

      case 'Y':
        return <Box><AdminLegalTemplateComponent/></Box>
      case 'Z':
        return <Box><AdminFaqComponent/></Box>
      case 'AA':
        return <Box><AdminLegalBlogsComponent/></Box>
      case 'BB':
        return <Box><AdminScamNewsComponent/></Box>
      case 'CC':
        return <Box><AdminHighCourtComponent/></Box>
      case 'DD':
        return <Box><AdminSupremeCourtComponent/></Box>
      case 'EE':
        return <Box><AdminOtherStateCourtComponent/></Box>

      case 'FF':
        return <Box><AdminSOPComponent/></Box>
      case 'GG':
        return <Box><AdminLegalOpinionComponent/></Box>
      case 'HH':
        return <Box><AdminLegalResearchComponent/></Box>
      
      case 'II':
        return <Box><OrgChartAdmin/></Box>

      case 'JJ':
        return <Box><AdminPropertyComponent/></Box>

      default:
        return <Typography variant="h6">Please select an option</Typography>;
    }
  };

  return (
    <Box sx={{ width: '100%', padding: 2 }}>
      <Box sx={{ width: 300 }}>
        <FormControl fullWidth>
          <InputLabel id="dropdown-label">Select Option</InputLabel>
          <Select labelId="dropdown-label" value={selectedOption} label="Select Option" onChange={handleChange}>
            <MenuItem value="A">Advertisement</MenuItem>
            <MenuItem value="B">Auctions</MenuItem>
            <MenuItem value="C">Calender Event</MenuItem>
            <MenuItem value="D">Circulars & Notifications</MenuItem>
            <MenuItem value="E">Special Court cases</MenuItem>
            <MenuItem value="F">FE</MenuItem>
            <MenuItem value="G">Assigned Financial Establishment</MenuItem>
            <MenuItem value="H">Govt Orders</MenuItem>
            <MenuItem value="I">Head Offices</MenuItem>
            <MenuItem value="J">Info to Depositor</MenuItem>
            <MenuItem value="K">Special Court Orders</MenuItem>
            <MenuItem value="L">KPID Act</MenuItem>
            <MenuItem value="M">Manuals & Videos</MenuItem>
            <MenuItem value="N">Office Orders</MenuItem>
            <MenuItem value="O">Tenders</MenuItem>
            <MenuItem value="P">News</MenuItem>
            <MenuItem value="Q">Home Notifications</MenuItem>
            <MenuItem value="R">Legal Team</MenuItem>
            <MenuItem value="S">Buds Act</MenuItem>
            <MenuItem value="T">Supreme Court Cases</MenuItem>
            <MenuItem value="U">High Court Cases</MenuItem>
            <MenuItem value="V">Other State PIDFE</MenuItem>
            <MenuItem value="W">Other Relevent Acts</MenuItem>
            <MenuItem value="X">Comparisn Of Acts</MenuItem>
            <MenuItem value="Y">Legal Template</MenuItem>
            <MenuItem value="Z">FAQ's</MenuItem>
            <MenuItem value="AA">Legal Blogs</MenuItem>
            <MenuItem value="BB">Scam News</MenuItem>
            <MenuItem value="CC">High Court Orders</MenuItem>
            <MenuItem value="DD">Supreme Court Orders</MenuItem>
            <MenuItem value="EE">Other State Court Orders</MenuItem>
            <MenuItem value="FF">SOP mgmt</MenuItem>
            <MenuItem value="GG">Legal Opinion</MenuItem>
            <MenuItem value="HH">Legal Research</MenuItem>
            <MenuItem value="II">Org Chart Mgmt</MenuItem>
            <MenuItem value="JJ">Property Map Mgmt</MenuItem>

          </Select>
        </FormControl>
      </Box>
      <Box sx={{ marginTop: 3, width: '100%' }}>
        {renderComponent()}
      </Box>
    </Box>
  );
};

export default DropdownComponent;
